import { useCallback } from "react";

import { navigate } from "gatsby";

import { setRedirectUrlSessionStorage } from "@/account/redirect";
import { SessionType } from "@/autoGeneratedGlobalTypes";
import { isSessionIdValid } from "@/utils/commonUtils";
import { isBrowser } from "@/utils/env";

import { NavigateToSessionOptions } from "./types";

/**
 * Hook для навигации к активной сессии
 *
 * Управляет переходом на страницы чата или видео звонка
 * с сохранением URL для редиректа после авторизации
 */
export const useSessionNavigation = () => {
  const navigateToSession = useCallback((
    sessionType: SessionType,
    sessionId?: number | null,
    options?: NavigateToSessionOptions,
  ) => {
    if (!isBrowser() || !isSessionIdValid(sessionId)) {
      return;
    }

    setRedirectUrlSessionStorage(window.location.pathname);

    // Формирование дополнительных URL параметров
    const urlParametersString = options?.urlParameters
      ? `&${Object.keys(options.urlParameters)
        .map((k) =>
          `${k}=${options.urlParameters![k]}`)
        .join("&")}`
      : "";

    const baseUrl = sessionType === SessionType.CHAT
      ? `/textChat?sessionId=${sessionId}`
      : `/chat?sessionId=${sessionId}`;

    navigate(`${baseUrl}${urlParametersString}`, options?.navigateOptions);
  }, []);

  return { navigateToSession };
};
